var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4466_9902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7011 33.4092L26.783 3.54258C25.8506 1.67591 23.2866 1.67591 22.3542 3.54258L7.20303 33.4092C6.27065 35.0426 7.66922 37.1426 9.53398 37.1426H39.3702C41.2349 37.1426 42.4004 35.0426 41.7011 33.4092ZM24.4521 32.4759C22.5873 32.4759 20.9556 30.8426 20.9556 28.9759C20.9556 27.1092 22.3542 25.4759 24.4521 25.4759C26.5499 25.4759 27.9485 27.1092 27.9485 28.9759C27.9485 31.0759 26.3168 32.4759 24.4521 32.4759ZM26.783 23.1426H22.1211L20.9556 14.9759C20.9556 14.2759 21.4218 13.8092 22.1211 13.8092H26.783C27.4823 13.8092 27.9485 14.2759 27.9485 14.9759L26.783 23.1426Z",
    fill: "#FEBF21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4466_9902",
    x: 0.90625,
    y: 0.142578,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.890724 0 0 0 0 0.616667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4466_9902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4466_9902",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/WarningTriangle.89832b622e314bb102fab0d41a4f1929.svg";
export { ForwardRef as ReactComponent };